import api from './authService'

export const childService = {
  // Get all children for the current user
  async getChildren(params = {}) {
    const response = await api.get('/children/', { params })
    return response.data
  },

  // Get a specific child by ID
  async getChild(childId) {
    const response = await api.get(`/children/${childId}/`)
    return response.data
  },

  // Create a new child
  async createChild(childData) {
    const formData = new FormData()
    
    // Add text fields
    formData.append('name', childData.name)
    formData.append('date_of_birth', childData.dateOfBirth)
    formData.append('gender', childData.gender)
    
    // Add profile picture if provided
    if (childData.profilePicture) {
      formData.append('profile_picture', childData.profilePicture)
    }

    const response = await api.post('/children/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  },

  // Update child information
  async updateChild(childId, childData) {
    const formData = new FormData()
    
    // Add text fields
    if (childData.name !== undefined) {
      formData.append('name', childData.name)
    }
    if (childData.dateOfBirth !== undefined) {
      formData.append('date_of_birth', childData.dateOfBirth)
    }
    if (childData.gender !== undefined) {
      formData.append('gender', childData.gender)
    }
    if (childData.isActive !== undefined) {
      formData.append('is_active', childData.isActive)
    }
    
    // Add profile picture if provided
    if (childData.profilePicture) {
      formData.append('profile_picture', childData.profilePicture)
    }

    const response = await api.patch(`/children/${childId}/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  },

  // Soft delete a child (deactivate)
  async deleteChild(childId) {
    const response = await api.delete(`/children/${childId}/`)
    return response.data
  },

  // Upload child profile photo
  async uploadPhoto(childId, photoFile) {
    const formData = new FormData()
    formData.append('profile_picture', photoFile)

    const response = await api.post(`/children/${childId}/upload-photo/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  },

  // Activate a deactivated child
  async activateChild(childId) {
    const response = await api.post(`/children/${childId}/activate/`)
    return response.data
  },

  // Get only active children
  async getActiveChildren() {
    const response = await api.get('/children/active/')
    return response.data
  },

  // Get children summary statistics
  async getChildrenSummary() {
    const response = await api.get('/children/summary/')
    return response.data
  },
}